<template>
  <div>
    <div class="mb-5">
      <h2 class="mb-0">Interaction Report</h2>
      <p class="mb-0">
        District identifier should be an email suffix, e.g. 'usd250.org'. All
        filters are optional -
        <b>report generation might take awhile with no filters</b>. Summarized
        counts show 'View' interactions.
      </p>
    </div>

    <div class="flex flex-wrap -mx-5">
      <d-field class="w-1/4 px-5" label="From Date">
        <d-datepicker v-model="fromDate" mode="date" required />
      </d-field>

      <d-field class="w-1/4 px-5" label="To Date">
        <d-datepicker v-model="toDate" mode="date" required />
      </d-field>

      <d-field class="w-1/4 px-5" label="Subject Area">
        <d-input v-model="subjectAreaName" />
      </d-field>

      <d-field class="w-1/4 px-5" label="District Identifier">
        <d-input v-model="districtIdentifier" />
      </d-field>
    </div>

    <div class="w-full px-5 flex justify-end mt-3">
      <d-btn :loading="loading" @click="getReportData()"> Load Report </d-btn>
    </div>

    <div v-if="reportData">
      <table border="1" class="mb-5 mt-5">
        <thead>
          <tr>
            <th style="width: 300px; text-align: left">Subject Area</th>
            <th style="width: 100px; text-align: left">View Count</th>
            <th style="width: 100px; text-align: left">Distinct Users</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="subjectArea in reportData"
            :key="subjectArea.subjectAreaName"
          >
            <td>{{ subjectArea.subjectAreaName }}</td>
            <td>{{ subjectArea.interactionCount }}</td>
            <td>{{ subjectArea.distinctUsers }}</td>
          </tr>
        </tbody>
      </table>

      <d-btn :loading="loading" @click="getReportDataExcel()">
        Export Detailed Data
      </d-btn>
    </div>
  </div>
</template>

<script>
// Import Pinia auth store
import { useAuthStore } from '@stores/auth';
import axios from "axios";
import debounce from "lodash/debounce";
import { showErrorToast } from "@services/errorHandling.service";

export default {
  parent: true,
  data: () => ({
    reportData: null,
    loading: false,
    fromDate: "",
    toDate: "",
    subjectAreaName: "",
    districtIdentifier: "",
    auth: null,
  }),

  computed: {
    // Use Pinia auth store's hasRole
    hasRole() {
      if (!this.auth) return () => false;
      return this.auth.hasRole;
    },
  },
  created() {
    this.auth = useAuthStore();
  },

  methods: {
    parseDate(dateString) {
      const date = new Date(dateString);
      return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
    },

    async getReportData() {
      this.loading = true;
      const params = [
        `fromDate=${this.parseDate(this.fromDate)}`,
        `toDate=${this.parseDate(this.toDate)}`,
        `districtIdentifier=${this.districtIdentifier}`,
        `subjectAreaName=${this.subjectAreaName}`,
      ].join("&");
      this.loading = true;
      const { data } = await axios.get(`/api/reports/interactions?${params}`);
      this.reportData = data;
      this.loading = false;

      if (data.length === 0) {
        showErrorToast("No interactions found for the given parameters");
      }
    },

    async getReportDataExcel() {
      const params = [
        `fromDate=${this.parseDate(this.fromDate)}`,
        `toDate=${this.parseDate(this.toDate)}`,
        `districtIdentifier=${this.districtIdentifier}`,
        `subjectAreaName=${this.subjectAreaName}`,
      ].join("&");
      window.location.href = `/api/reports/interactions/export?${params}`;
    },
  },
};
</script>
